// Runtime Configuration Manager
// This allows dynamic configuration changes without rebuilding

class RuntimeConfig {
  constructor() {
    this.config = {
      website: {
        title: 'BTMS',
        subtitle: 'Transport Management System with GPS Tracking',
        icon: '/media/tracking.png',
        logo: 'BTMS',
        colors: {
          primary: '#03193b',
          secondary: '#1F1F1F',
          accent: '#D98324'
        }
      },
      app: {
        name: 'BTMS',
        version: '1.0.0',
        description: 'Transport Management System with GPS Tracking capabilities'
      }
    }
    
    this.listeners = []
    this.loadFromStorage()
  }

  // Load configuration from localStorage
  loadFromStorage() {
    try {
      const stored = localStorage.getItem('tms-config')
      if (stored) {
        const parsed = JSON.parse(stored)
        this.config = { ...this.config, ...parsed }
      }
    } catch (error) {
      console.warn('Failed to load config from storage:', error)
    }
  }

  // Save configuration to localStorage
  saveToStorage() {
    try {
      localStorage.setItem('tms-config', JSON.stringify(this.config))
    } catch (error) {
      console.warn('Failed to save config to storage:', error)
    }
  }

  // Get configuration value
  get(path) {
    return path.split('.').reduce((obj, key) => obj?.[key], this.config)
  }

  // Set configuration value
  set(path, value) {
    const keys = path.split('.')
    const lastKey = keys.pop()
    const target = keys.reduce((obj, key) => obj[key] = obj[key] || {}, this.config)
    target[lastKey] = value
    
    this.saveToStorage()
    this.notifyListeners()
  }

  // Update multiple configuration values
  update(updates) {
    Object.assign(this.config, updates)
    this.saveToStorage()
    this.notifyListeners()
  }

  // Reset to default configuration
  reset() {
    this.config = {
      website: {
        title: 'BTMS',
        subtitle: 'Transport Management System with GPS Tracking',
        icon: '/media/tracking.png',
        logo: 'BTMS',
        colors: {
          primary: '#03193b',
          secondary: '#1F1F1F',
          accent: '#D98324'
        }
      },
      app: {
        name: 'BTMS',
        version: '1.0.0',
        description: 'Transport Management System with GPS Tracking capabilities'
      }
    }
    
    localStorage.removeItem('tms-config')
    this.notifyListeners()
  }

  // Get all configuration
  getAll() {
    return { ...this.config }
  }

  // Subscribe to configuration changes
  subscribe(callback) {
    this.listeners.push(callback)
    return () => {
      const index = this.listeners.indexOf(callback)
      if (index > -1) {
        this.listeners.splice(index, 1)
      }
    }
  }

  // Notify all listeners of configuration changes
  notifyListeners() {
    this.listeners.forEach(callback => callback(this.config))
  }

  // Apply colors to CSS custom properties
  applyColors() {
    const root = document.documentElement
    root.style.setProperty('--primary-color', this.config.website.colors.primary)
    root.style.setProperty('--secondary-color', this.config.website.colors.secondary)
    root.style.setProperty('--accent-color', this.config.website.colors.accent)
    root.style.setProperty('--active-color', this.config.website.colors.accent)
  }

  // Update page title and favicon
  updatePageMeta() {
    const titleElement = document.getElementById('page-title')
    const faviconElement = document.getElementById('favicon')
    
    if (titleElement) {
      titleElement.textContent = this.config.website.title
    }
    
    if (faviconElement) {
      faviconElement.href = this.config.website.icon
    }
  }
}

// Create singleton instance
const runtimeConfig = new RuntimeConfig()

// Apply initial configuration
runtimeConfig.applyColors()
runtimeConfig.updatePageMeta()

export default runtimeConfig
